<div class="row mb-3">
	<div class="col">
		<button type="button" class="btn btn-link btn-sm p-0 mb-2" (click)="backToNotes.emit()">
			<fa-icon [icon]="['fas', 'chevron-left']"></fa-icon> Back to notes
		</button>
	</div>
</div>
<pk-broker-loader [show]="loading"></pk-broker-loader>
@if (!loading) {
	<div class="row">
		<div class="col">
			<h5 class="mb-2">Edit this supplier's note.</h5>
			<p class="mb-4">Supplier: {{ rfqSessionSupplier.supplier.name }}</p>
		</div>
	</div>
	<form [formGroup]="formGroup">
		<div class="row">
			<div class="col">
				<div class="form-element-container">
					<label class="title required" for="note">Note</label>
					<textarea class="form-control" id="note" maxlength="1000" formControlName="note"></textarea>
				</div>
			</div>
		</div>
	</form>
	<div class="row d-flex justify-content-end">
		<div class="col-auto">
			<button type="button" class="btn btn-link btn-sm" (click)="backToNotes.emit()"><fa-icon [icon]="['fas', 'times']"></fa-icon> Cancel</button>
		</div>
		<div class="col-auto">
			<button type="button" class="btn btn-primary btn-sm" (click)="submit()" [disabled]="submitDisabled">
				<fa-icon [icon]="['fas', 'save']"></fa-icon> {{ submitText }}
			</button>
		</div>
	</div>
}
